module.exports = __webpack_public_path__ + "img/wind.ac59cd39.gif";